import { createSelector } from 'reselect';
import get from 'lodash/get';
import { FIRST_PAGE, DISPLAYED_PAGES_QUANTITY } from './constants';
import { searchParametersSelector, linksSelector } from '../../../selectors';
import {
  queryAlertLandingSelector,
  queryOriginSelector,
  queryDsaTgSelector,
} from '~/request/query/selectors';
import { getVerticalName } from '~/common/selectors/config';
import getPageParams from './utils/getPageParams';

export const getCurrentPage = state => get(searchParametersSelector(state), 'page');

export function getMaxPage(state) {
  return get(linksSelector(state), 'maxPage');
}

export function getNextPageNumber(state) {
  const currentPage = getCurrentPage(state);
  return currentPage < getMaxPage(state) ? currentPage + 1 : null;
}

export function getPreviousPageNumber(state) {
  const currentPage = getCurrentPage(state);

  return currentPage > FIRST_PAGE ? currentPage - 1 : null;
}

export const getCurrentPageSet = createSelector(
  [getCurrentPage, getMaxPage],
  (currentPage, maxPage) => {
    const pageSet = [];
    const maxPageInt = Number.parseInt(maxPage, 10);

    // We calculate the first page number of the set
    let page = currentPage - Math.trunc(DISPLAYED_PAGES_QUANTITY / 2);
    if (page < FIRST_PAGE + 1) {
      page = FIRST_PAGE;
    } else if (currentPage >= maxPageInt - 1) {
      page = maxPage - DISPLAYED_PAGES_QUANTITY + 1 || FIRST_PAGE; // guard undesired 0 as a result
    }

    while (pageSet.length < DISPLAYED_PAGES_QUANTITY && pageSet.length !== maxPageInt) {
      pageSet.push(page);
      page += 1;
    }

    return pageSet;
  }
);

export const getCurrentPageSetParams = createSelector(
  [
    getCurrentPageSet,
    searchParametersSelector,
    getVerticalName,
    queryOriginSelector,
    queryAlertLandingSelector,
    queryDsaTgSelector,
  ],
  (currentPageSet, searchParameters, verticalName, queryOrigin, alertLanding, tg) =>
    currentPageSet.map(page =>
      getPageParams(page, searchParameters, verticalName, queryOrigin, alertLanding, tg)
    )
);

export const getNextPageParams = createSelector(
  [
    getNextPageNumber,
    searchParametersSelector,
    getVerticalName,
    queryOriginSelector,
    queryAlertLandingSelector,
    queryDsaTgSelector,
  ],
  (nextPageNumber, searchParameters, verticalName, queryOrigin, alertLanding, tg) =>
    getPageParams(nextPageNumber, searchParameters, verticalName, queryOrigin, alertLanding, tg)
);

export const getPreviousPageParams = createSelector(
  [
    getPreviousPageNumber,
    searchParametersSelector,
    getVerticalName,
    queryOriginSelector,
    queryAlertLandingSelector,
    queryDsaTgSelector,
  ],
  (previousPageNumber, searchParameters, verticalName, queryOrigin, alertLanding, tg) =>
    getPageParams(previousPageNumber, searchParameters, verticalName, queryOrigin, alertLanding, tg)
);



// WEBPACK FOOTER //
// ./app/Serp/components/shared/Pager/selectors.js